import {
  Card,
  Col,
  Row,
  Statistic,
  Tooltip,
  Empty,
  message,
  Avatar,
  Tabs,
  Table,
  Divider,
  Input,
  Button,
  Radio,
  DatePicker,
} from "antd";
import React, { Component, useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle } from "react";
import styles from "./style.module.less";
import * as apis from "@/apis";
import { connect, useSelector } from "react-redux";
import dayjs from 'dayjs'
import { saveAs } from 'file-saver';
import { getCurrentUser } from '@/models/user/selectors';

const Manager = forwardRef((props, ref) => {
  const [limit, setLimit] = useState(30);
  const [offset, setOffset] = useState(0);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [queryParams, setQueryParams] = useState({});

  const typeMap = new Map()
  typeMap.set(1, '今天')
  typeMap.set(2, '本周')
  typeMap.set(3, '本月')
  typeMap.set(4, '本年')

  useImperativeHandle(ref, () => ({
    fetchList: (params = {}) => {
      fetchList({
        limit: 30,
        offset: 0,
        ...params
      })
    }
  }));

  const columns = [
    {
      title: '序号',
      key: '_id',
      width: 60,
      align: 'center',
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '客服',
      width: 200,
      key: 'realname',
      render: item => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginRight: 10 }}>
            <Avatar size={40} src={item.avatar} />
          </div>
          <div>{item.realname}</div>
        </div>
      )
    },
    {
      // title: typeMap.get(props.dateType)+'平均工单数',
      title: '平均日工单数',
      width: 160,
      align: 'center',
      key: 'day_num',
      dataIndex: 'day_num',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.day_num - b.day_num,
    },
    {
      title: '平均工单利润(元) 已结算',
      width: 160,
      align: 'center',
      key: 'profit',
      dataIndex: 'profit',
      sorter: (a, b) => a.profit - b.profit,
    },
    {
      title: '辅助单数',
      width: 160,
      align: 'center',
      key: 'assist',
      dataIndex: 'assist',
      sorter: (a, b) => a.assist - b.assist,
    },
    {
      title: '工单取消率',
      width: 160,
      align: 'center',
      key: 'cancel',
      dataIndex: 'cancel',
      sorter: (a, b) => parseFloat(a.cancel) - parseFloat(b.cancel),
    },
    {
      title: '工单平均指派用时长',
      width: 160,
      align: 'center',
      key: 'avg_time',
      dataIndex: 'avg_time',
    },
    {
      title: '总共接单数',
      width: 160,
      align: 'center',
      key: 'totalOrders',
      dataIndex: 'totalOrders',
      sorter: (a, b) => a.totalOrders - b.totalOrders,
    },
  ]
  const fetchList = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || params.offset === 0 ? params.offset : offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)
    setQueryParams(params)

    apis
      .queryDashboardCustom(params)
      .then((data) => {
        setItems(data.returnData || [])
        setTotal(data.total || 0)
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [queryParams])
  const handleTableChange = (pagination, filters, sorter) => {

    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }
    // if (sorter && sorter.field) {
    //   nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    // }
    // fetchList(nextQuery)

    setLimit(pagination.pageSize)
    setOffset(nextQuery.offset)
  }

  useEffect(() => {
    fetchList(
      {
        stime: dayjs().format("YYYY-MM-DD"),
        etime: dayjs().format("YYYY-MM-DD")
      }
    )
    return () => { }
  }, [])

  return (
    <div>
      <Table
        rowKey="realname"
        size="middle"
        columns={columns}
        dataSource={items}
        onChange={handleTableChange}
        loading={loading}
        scroll={{ x: '100%' }}
        pagination={{
          showQuickJumper: true,
          total: total,
          pageSize: +limit,
          current: Math.floor(offset / +limit) + 1,
          showTotal: total => `共 ${total} 条`
        }}
      ></Table>
    </div>
  )
})
const Tenant = forwardRef((props, ref) => {
  const [limit, setLimit] = useState(30);
  const [offset, setOffset] = useState(0);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [queryParams, setQueryParams] = useState({});
  const typeMap = new Map()
  typeMap.set(1, '今天')
  typeMap.set(2, '本周')
  typeMap.set(3, '本月')
  typeMap.set(4, '本年')

  useImperativeHandle(ref, () => ({
    fetchList: (params = {}) => {
      fetchList({
        limit: 30,
        offset: 0,
        ...params
      })
    }
  }));

  const columns = [
    {
      title: '序号',
      key: '_id',
      width: 60,
      align: 'center',
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '商家',
      width: 200,
      key: 'name',
      dataIndex: 'name',
    },
    {
      title: typeMap.get(props.dateType) + '工单总数',
      width: 160,
      align: 'center',
      key: 'cur_num',
      dataIndex: 'cur_num',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.cur_num - b.cur_num,
    },
    {
      title: '取消工单总数',
      width: 160,
      align: 'center',
      key: 'cancel_num',
      dataIndex: 'cancel_num',
      sorter: (a, b) => a.cancel_num - b.cancel_num,
    },
    {
      title: '工单取消率',
      width: 160,
      align: 'center',
      key: 'cancel_percent',
      dataIndex: 'cancel_percent',
      sorter: (a, b) => parseFloat(a.cancel_percent) - parseFloat(b.cancel_percent),
    },
    {
      title: '平均成交价',
      width: 160,
      align: 'center',
      key: 'avg_price',
      dataIndex: 'avg_price',
      sorter: (a, b) => a.avg_price - b.avg_price,
    },
    {
      title: '平均利润',
      width: 160,
      align: 'center',
      key: 'profit',
      dataIndex: 'profit',
      sorter: (a, b) => a.profit - b.profit,
    },
  ]
  const fetchList = useCallback((params = {}) => {
    params = { ...queryParams, ...params }
    params.offset = params.offset || params.offset === 0 ? params.offset : offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)
    setQueryParams(params)
    apis
      .queryDashboardCompany(params)
      .then((data) => {
        setItems(data.returnData || [])
        setTotal(data.total || 0)
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [queryParams])
  const handleTableChange = (pagination, filters, sorter) => {

    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }
    // if (sorter && sorter.field) {
    //   nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    // }
    // fetchList(nextQuery)

    setLimit(pagination.pageSize)
    setOffset(nextQuery.offset)
  }

  useEffect(() => {
    fetchList(
      {
        stime: dayjs().format("YYYY-MM-DD"),
        etime: dayjs().format("YYYY-MM-DD")
      }
    )
    return () => { }
  }, [])

  return (
    <div>
      <Table
        rowKey="name"
        size="middle"
        columns={columns}
        dataSource={items}
        onChange={handleTableChange}
        loading={loading}
        scroll={{ x: '100%' }}
        pagination={{
          showQuickJumper: true,
          total: total,
          pageSize: +limit,
          current: Math.floor(offset / +limit) + 1,
          showTotal: total => `共 ${total} 条`
        }}
      ></Table>
    </div>
  )
})
const Worker = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState({});

  useImperativeHandle(ref, () => ({
    fetchList: (params = {}) => {
      fetchList({
        ...params
      })
    }
  }));


  const fetchList = useCallback((params = {}) => {
    setLoading(true)

    apis
      .queryDashboardWorker(params)
      .then((data) => {
        setItems(data.returnData || {})
      })
      .catch((error) => {
        message.error(error.message || "获取数据失败");
      }).finally(() => {
        setLoading(false)
      })
  }, [])


  useEffect(() => {
    fetchList(
      {
        stime: dayjs().format("YYYY-MM-DD"),
        etime: dayjs().format("YYYY-MM-DD")
      }
    )
    return () => { }
  }, [])

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker1.png" />
              <div className={styles.title}>当前师傅总数</div>
              <div className={styles.num}>{items.total || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker2.png" />
              <div className={styles.title}>新注册师傅</div>
              <div className={styles.num}>{items.register || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker3.png" />
              <div className={styles.title}>保证金师傅总数</div>
              <div className={styles.num}>{items.margin || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker4.png" />
              <div className={styles.title}>新增保证金师傅</div>
              <div className={styles.num}>{items.marginNew || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker5.png" />
              <div className={styles.title}>老兵师傅总数</div>
              <div className={styles.num}>{items.veteran || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker6.png" />
              <div className={styles.title}>新增老兵</div>
              <div className={styles.num}>{items.veteranNew || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker7.png" />
              <div className={styles.title}>差评数</div>
              <div className={styles.num}>{items.bad || 0}</div>
            </div>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} style={{ borderRadius: '6px' }}>
            <div className={styles.carditem}>
              <img className={styles.icon} src="/images/das-worker8.png" />
              <div className={styles.title}>好评数</div>
              <div className={styles.num}>{items.praise || 0}</div>
            </div>
          </Card>
        </Col>

      </Row>
    </div>
  )
})


const Dashboard = () => {
  const user = useSelector(getCurrentUser);
  const [type, setType] = useState('1');
  const [dateType, setDateType] = useState(1);
  const [dateRange, setDateRange] = useState([]);
  const [keyword, setKeyword] = useState('');

  const managerRef = useRef(null);
  const tenantRef = useRef(null);
  const workerRef = useRef(null);

  const dateRadioChange = (e) => {
    const dType = e.target.value;
    setDateType(dType)
    setDateRange([])
    const params = {}
    if (dType == 1) {
      params.stime = dayjs().format("YYYY-MM-DD")
      params.etime = dayjs().format("YYYY-MM-DD")
    } else if (dType == 2) {
      params.stime = dayjs().startOf("week").format("YYYY-MM-DD")
      params.etime = dayjs().endOf("week").format("YYYY-MM-DD")
    } else if (dType == 3) {
      params.stime = dayjs().startOf("month").format("YYYY-MM-DD")
      params.etime = dayjs().endOf("month").format("YYYY-MM-DD")
    } else if (dType == 4) {
      params.stime = dayjs().startOf("year").format("YYYY-MM-DD")
      params.etime = dayjs().endOf("year").format("YYYY-MM-DD")
    }
    if (keyword) {
      params.keyword = keyword
    }
    if (type == 1) {
      managerRef.current.fetchList(params)
    } else if (type == 2) {
      tenantRef.current.fetchList(params)
    } else if (type == 3) {
      workerRef.current.fetchList(params)
    }

  }
  const downloadFile = () => {
    const params = {}
    if (dateType == -1) {
      if (dateRange.length) {
        params.stime = dayjs(dateRange[0]).format("YYYY-MM-DD")
        params.etime = dayjs(dateRange[1]).format("YYYY-MM-DD")
      }
    } else {
      if (dateType == 1) {
        params.stime = dayjs().format("YYYY-MM-DD")
        params.etime = dayjs().format("YYYY-MM-DD")
      } else if (dateType == 2) {
        params.stime = dayjs().startOf("week").format("YYYY-MM-DD")
        params.etime = dayjs().endOf("week").format("YYYY-MM-DD")
      } else if (dateType == 3) {
        params.stime = dayjs().startOf("month").format("YYYY-MM-DD")
        params.etime = dayjs().endOf("month").format("YYYY-MM-DD")
      } else if (dateType == 4) {
        params.stime = dayjs().startOf("year").format("YYYY-MM-DD")
        params.etime = dayjs().endOf("year").format("YYYY-MM-DD")
      }
    }

    if (keyword) {
      params.keyword = keyword
    }

    const month = dayjs().subtract(1, 'months').format('YYYY-MM')
    if (type == 1) {
      apis.downloadManagerDump(params).then(res => {
        saveAs(res, `${month} - 客服.csv`)
      }).catch(err => {
        message.error(err?.message || '获取数据失败，请刷新重试');
      })
    } else if (type == 2) {
      apis.downloadTenantDump(params).then(res => {
        saveAs(res, `${month} - 商家.csv`)
      }).catch(err => {
        message.error(err?.message || '获取数据失败，请刷新重试');
      })
    }

  }

  return (
    <>
      <div className={styles.blockstyle}>
        <Tabs
          animated={false}
          activeKey={type}
          tabBarStyle={{ border: 0 }}
          onChange={(key) => {
            setType(key)
            setDateType(1)
            setDateRange([])
            setKeyword('')
          }}>
          <Tabs.TabPane tab="客服" key="1">
            <div className={styles.searchwrap}>
              <Input.Search
                allowClear={true}
                placeholder="请输入您要搜索的关键字"
                style={{ width: 250 }}
                onChange={e => {
                  setKeyword(e.target.value)
                }}
                onSearch={value => {
                  setKeyword(value)
                  setDateType(value ? -1 : 1)
                  const params = {}
                  if (dateRange.length) {
                    params.stime = dayjs(dateRange[0]).format("YYYY-MM-DD")
                    params.etime = dayjs(dateRange[1]).format("YYYY-MM-DD")
                  }
                  if (value) {
                    params.keyword = value
                  }
                  managerRef.current.fetchList(params)
                }}
              />
              <div className={styles.date}>
                <Radio.Group value={dateType} buttonStyle="solid" style={{ marginRight: 10 }}
                  onChange={dateRadioChange}
                >
                  <Radio.Button value={1}>今天</Radio.Button>
                  <Radio.Button value={2}>本周</Radio.Button>
                  <Radio.Button value={3}>本月</Radio.Button>
                  <Radio.Button value={4}>本年</Radio.Button>
                </Radio.Group>
                <div>
                  自定义时间
                  <DatePicker.RangePicker
                    value={dateRange}
                    format="YYYY-MM-DD"
                    style={{ marginLeft: 10, width: 250 }}
                    onChange={(e) => {
                      setDateRange(e)
                      const params = {}
                      if (e.length) {
                        params.stime = dayjs(e[0]).format("YYYY-MM-DD")
                        params.etime = dayjs(e[1]).format("YYYY-MM-DD")
                        setDateType(-1)
                      } else {
                        setDateType(1)
                      }
                      if (keyword) {
                        params.keyword = keyword
                      }
                      managerRef.current.fetchList(params)
                    }} />
                </div>

                <Button type="primary" style={{ marginLeft: '10px' }} onClick={() => { downloadFile() }}>下载</Button>
              </div>
            </div>
          </Tabs.TabPane>
          {user.get('isAdmin') && <Tabs.TabPane tab="商家" key="2">
            <div className={styles.searchwrap} style={{ justifyContent: 'flex-start' }}>
              <Input.Search
                allowClear={true}
                placeholder="请输入您要搜索的关键字"
                style={{ width: 250 }}
                onChange={e => {
                  setKeyword(e.target.value)
                }}
                onSearch={value => {
                  setKeyword(value)
                  setDateType(value ? -1 : 1)
                  const params = {}
                  if (dateRange.length) {
                    params.stime = dayjs(dateRange[0]).format("YYYY-MM-DD")
                    params.etime = dayjs(dateRange[1]).format("YYYY-MM-DD")
                  }
                  if (value) {
                    params.keyword = value
                  }
                  tenantRef.current.fetchList(params)
                }}
              />
              <div className={styles.date}>
                <Radio.Group value={dateType} buttonStyle="solid" style={{ marginRight: 10 }}
                  onChange={dateRadioChange}
                >
                  <Radio.Button value={1}>今天</Radio.Button>
                  <Radio.Button value={2}>本周</Radio.Button>
                  <Radio.Button value={3}>本月</Radio.Button>
                  <Radio.Button value={4}>本年</Radio.Button>
                </Radio.Group>
                <div>
                  自定义时间
                  <DatePicker.RangePicker
                    value={dateRange}
                    format="YYYY-MM-DD"
                    style={{ marginLeft: 10, width: 250 }}
                    onChange={(e) => {
                      setDateRange(e)
                      const params = {}
                      if (e.length) {
                        params.stime = dayjs(e[0]).format("YYYY-MM-DD")
                        params.etime = dayjs(e[1]).format("YYYY-MM-DD")
                        setDateType(-1)
                      } else {
                        setDateType(1)
                      }
                      if (keyword) {
                        params.keyword = keyword
                      }
                      tenantRef.current.fetchList(params)
                    }} />
                </div>
              </div>
              <div style={{
                flex: 1,
                textAlign: 'right'
              }}><Button type="primary" style={{ marginLeft: '10px' }} onClick={() => { downloadFile() }}>下载</Button></div>
            </div>
          </Tabs.TabPane>}
          {user.get('isAdmin') && <Tabs.TabPane tab="师傅" key="3">
            <div className={styles.searchwrap} style={{ justifyContent: 'flex-start' }}>

              <div className={styles.date}>
                <Radio.Group value={dateType} buttonStyle="solid" style={{ marginRight: 10 }}
                  onChange={dateRadioChange}
                >
                  <Radio.Button value={1}>今天</Radio.Button>
                  <Radio.Button value={2}>本周</Radio.Button>
                  <Radio.Button value={3}>本月</Radio.Button>
                  <Radio.Button value={4}>本年</Radio.Button>
                </Radio.Group>
                <div>
                  自定义时间
                  <DatePicker.RangePicker
                    value={dateRange}
                    format="YYYY-MM-DD"
                    style={{ marginLeft: 10, width: 250 }}
                    onChange={(e) => {
                      setDateRange(e)
                      const params = {}
                      if (e.length) {
                        params.stime = dayjs(e[0]).format("YYYY-MM-DD")
                        params.etime = dayjs(e[1]).format("YYYY-MM-DD")
                        setDateType(-1)
                      } else {
                        setDateType(1)
                      }
                      if (keyword) {
                        params.keyword = keyword
                      }
                      workerRef.current.fetchList(params)
                    }} />
                </div>
              </div>
            </div>
          </Tabs.TabPane>}
        </Tabs>
      </div>

      {type == 1 && <div className={styles.blockstyle}><Manager dateType={dateType} ref={managerRef} /></div>}
      {type == 2 && <div className={styles.blockstyle}><Tenant dateType={dateType} ref={tenantRef} /></div>}
      {type == 3 && <Worker ref={workerRef} />}
      {/* <GridContent style={{ padding: "0 20px" }}>
          <React.Fragment>
            <Row gutter={[16, 16]}>
              <Col span={20}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card title="日工单量(近60天)" bordered={false}>
                      <div className={styles.mapChart}>
                        <Chart1 data={countOfPerDay} />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card title="企业工单数排行(近30日)" bordered={false}>
                      <div className={styles.mapChart}>
                        <TenantOrders data={activeTenantRanking} />
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card title="产品排行" bordered={false}>
                      <div className={styles.mapChart}>
                        <ProductList data={productRanking} />
                      </div>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card
                      title="全年利润"
                      bordered={false}
                      className={styles.pieCard}
                    >
                      <AnnualProfit data={fullYearProfit} />
                    </Card>
                  </Col>
                </Row>

                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card
                      title="推广员支出"
                      bordered={false}
                      className={styles.pieCard}
                    >
                      <PromoterExpenditure />
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card
                      // https://www.jianshu.com/p/0a53bc4f30db
                      title="客服接单排行"
                      bordered={false}
                    >
                      <div className={styles.mapChart}>
                        <CustomerServiceRanking data={customerServiceRanking} />
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col xl={4}>
                <Card
                  className={styles.card}
                  title="工单耗时排行"
                  style={{
                    marginBottom: 24,
                  }}
                  bordered={false}
                >
                  <BacklogOrders data={timeConsumeOrderRanking} />
                </Card>

                <Card
                  title="活跃师傅排行"
                  className={styles.card}
                  bodyStyle={{
                    textAlign: "center",
                    fontSize: 0,
                  }}
                  bordered={false}
                >
                  <ActiveWorkerRanking data={activeWorkerRanking} />
                </Card>
              </Col>
            </Row>
          </React.Fragment>
        </GridContent> */}
    </>
  );

}

export default connect()(Dashboard);
